var render = function render(){var _vm=this,_c=_vm._self._c;return _c(`Dev${_vm.currentComponent.charAt(0).toUpperCase() + _vm.currentComponent.slice(1)}`,{tag:"component"})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }